import type { Zoi } from '$lib/components/zoi/types';
import { resolve } from '$app/paths';
import { ROUTE_ZOI } from '$lib/constants/route';
import { defaultPoiCategories } from '$lib/constants/searchParams';
import { getLanguageCode } from '$lib/i18n/language';
import { i18nPath } from '$lib/i18n/routing';
import { type SearchParams, serializeSearchParams } from '$lib/services/urls/searchParams';

export function createZoiUrl(searchParams: SearchParams, zoi: Zoi) {
	const sp = serializeSearchParams({
		...searchParams,
		poiCategories: defaultPoiCategories,
		zoi: { center: zoi.center, radius: zoi.radius },
	});

	return resolve(i18nPath(`${ROUTE_ZOI}?${sp}`, getLanguageCode()) as any);
}
